<template>
  <div class="lower-third" ref="element">
    <div class="lt-box">
      <!-- <img :src="icon" alt="" class="lt-icon"> -->
      <div class="text-container">
        <span class="lt-title" v-if="title.length">{{ title }}</span>
        <span class="lt-content">{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LowerThird',

  data() {
    return {
      title: '',
      text: '',
      icon: 'https://proto-assets.s3.amazonaws.com/Ache/Assets/logo-gc.png',
    };
  },

  methods: {
    updateAndShow(content) {
      this.text = content.lowerthird.text;
      this.title = content.lowerthird.title;
      this.show();
    },

    show() {
      this.$refs.element.classList.add('visible');
    },

    hide() {
      this.$refs.element.classList.remove('visible');
    },
  },

  mounted() {
    /*websocket.addListener('show-lowerthird', this.updateAndShow);
        websocket.addListener('hide-lowerthird', this.hide);*/
  },

  beforeDestroy() {
    /*websocket.removeListener('show-lowerthird', this.updateAndShow);
        websocket.removeListener('hide-lowerthird', this.hide);*/
  },
};
</script>

<style lang="scss">
.lower-third {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.lt-box {
  position: relative;
  padding: 10px 20px;
  margin-bottom: 50px;
  max-width: 88%;
  transform: scaleX(0);
  transition: transform cubic-bezier(1, 0, 0, 1) 0.4s;
  background-color: var(--main-color);
  border: 0px solid var(--secondary-color);
  border-radius: var(--input-borderRadius);
  transition-delay: 0s;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text-container {
  position: relative;
  flex-grow: 1;
  // min-height: 28px;
  max-height: 120px;
  overflow-y: auto;
  pointer-events: auto;
}

.lt-content,
.lt-title {
  font-size: 1.1rem;
  opacity: 0;
  color: var(--text-color);
  transition: opacity cubic-bezier(1, 0, 0, 1) 0.4s;
  transition-delay: 0.2s;
}

.lt-title {
  font-weight: bold;
  background-color: var(--main-color);
  border-radius: 5px;
  padding: 4px 4px 4px 0;

  &:after {
    content: ":";
  }
}

.lt-icon {
  position: relative;
  margin-right: 20px;
  max-height: 80px;
}

.lower-third.visible {
  .lt-box {
    transform: scaleX(1);
    transition-delay: 0.2s;
  }

  .lt-content,
  .lt-title {
    opacity: 1;
    transition-delay: 0s;
  }
}
.lt-volume-medium-outline {
  position: relative;
  width: 10%;
  min-width: 30px;
  font-size: 2rem;
  margin-right: 20px;
}
</style>